import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Card } from './../model/card';
import { CardsEventType } from './../cards.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { CardsService } from '../cards.service';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ConfirmationComponent implements OnInit {

	@Input() submited = false;
	@Input() cardData: Card;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup;
	private view = '[data-component="confirmation-cards"]';
	public active: boolean = false;
	private confirmList: Array<ListItem> = [];

	disabled = false;

	constructor(private cardsService: CardsService, private autenticationService: AutenticationService) { }

	ngOnInit() {

		AppEventDispatcher.listen(CardsEventType.STEPS.CONFIRM_CARDS, data => {
			if (data.show) {
				this.setTitle.emit({
					title: 'Confirmação de ' + (this.cardData.state == 17 || this.cardData.state == 11 ? 'Desbloqueio' : 'Bloqueio') + ' de Cartão',
				});

				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CardsEventType.STEPS.CONFIRM_CARDS);
	}

	show() {
		this.preload(true);
		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 40;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });

			this.preload(false);
		});
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	hide() {

		this.preload(true);
		this.disabled = true;

		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(pass => {

			if (pass.Sucesso) {

				this.preload(true);
				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);

				this.cardsService.confirmUnlockOrBlockCard(this.cardData).subscribe(data => {

					this.cardData.message = data.Mensagem;
					this.cardData.success = data.Sucesso;

					if (time > 3) {
						this.preload(false);
						this.disabled = false;
						this.hideAfterSend();
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
							this.disabled = false;
							this.hideAfterSend();
						});
					}
					clearInterval(timeLoader);

				}, error => {

					if (time > 3) {
						this.preload(false);
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
						});
					}

					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					clearInterval(timeLoader);
				});

			}

		}, error => {
			this.preload(false);
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});


	}

	hideAfterSend() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(CardsEventType.STEPS.LIST_CARDS, { show: true });
			TweenMax.to(this.view, .8, {
				left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
				}
			});
		});
	}

	buildConfirmList() {
		this.confirmList = [];
		this.confirmList.push(new ListItem('Cartão:', ' xxxx xxxx xxxx ' + this.cardData.num));

		this.cardData.resumeList = this.confirmList;
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="cards"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/confirmation/confirmation.component.ts